import React, { useEffect, useState, useRef, useImperativeHandle, useMemo, forwardRef, useCallback } from 'react';

import AntToolbar from './AntToolbar';
import AntSettingGrid from './AntSettingGrid';
// import AntSettingTree from './AntSettingTree';
// import AntImport from './AntImport';
import AntSettingForm from './AntSettingForm';
// import AntVoucherCreationPopup from './AntVoucherCreationPopup';
// import AntVoucherEditPopup from './AntVoucherEditPopup';
import AntMessageBox from './AntMessageBox';
import AntCondition from '../utils/AntCondition';
import AntAPI from '../utils/AntAPI';
import AntAuth from '../utils/AntAuth';
import AntConfig from '../utils/AntConfig';

import { AntGlobal, AntSession } from '../utils/AntContext';

export default forwardRef(function (props, ref) {
    const appGlobal = AntGlobal();

    if (props.API && !props.API.entityDisplay) {
        if (appGlobal && appGlobal.appConfig && appGlobal.appConfig.Services) {
            let found = appGlobal.appConfig.Services.find((s) => s.name === props.API.entityName);
            if (found) props.API.init({ entityDisplay: found.display });
        }
    }

    const API = props.API ? props.API : new AntAPI('setting', 'BusinessSetting');

    const tableName = props.table ? props.table : API ? API.entityName : '';
    const entityName = API && API.entityName ? API.entityName : '';
    const entityDisplay = API && API.entityDisplay ? API.entityDisplay : props.entityDisplay ? props.entityDisplay : '';

    const config = useMemo(() => {
        let found = appGlobal.tableConfigs?.find((t) => t.tableName === tableName);
        if (found) return found.config;

        let cnf = new AntConfig(appGlobal, tableName);
        cnf.configFields(props.fields);

        if (appGlobal.tableConfigs instanceof Array === false) appGlobal.tableConfigs = [];

        appGlobal.tableConfigs.push({
            tableName: tableName,
            config: cnf
        });
        return cnf;
    }, []);

    const gridSearchConditions = useMemo(() => (props.grid && props.grid.searchConditions ? props.grid.searchConditions : {}), []);
    const treeSearchConditions = useMemo(() => (props.tree && props.tree.searchConditions ? props.tree.searchConditions : {}), []);

    const initFormSearchConditions = () => {
        var obj = {};

        if (props.parent && props.childField) {
            if (props.parentId) obj[props.childField] = props.parent.id;
            if (props.parentCode) obj[props.childField] = props.parent.code;
        }
        if (props.form && typeof props.form.searchConditions === 'object' && props.form.searchConditions !== null)
            obj = { ...obj, ...props.form.searchConditions };

        return obj;
    };
    const formSearchConditions = useMemo(() => initFormSearchConditions(), []);

    const initSearchFields = (comp, searchCond) => {
        var ar = [];
        if (comp) {
            if (comp && comp.searchFields instanceof Array)
                comp.searchFields.forEach((f) => {
                    ar.push(f);
                });
            Object.keys(searchCond).map((f) => {
                ar.push(f);
            });
        }
        return ar;
    };

    const gridSearchFields = useMemo(() => initSearchFields(props.grid, gridSearchConditions), []);
    const treeSearchFields = useMemo(() => initSearchFields(props.tree, treeSearchConditions), []);

    const form = useRef();
    const grid = useRef();
    const tree = useRef();
    const msgBox = useRef();

    AntAuth.checkValidSession();

    const isAllowQuery = () => {
        if (props.childField) {
            return parentInfo && parentInfo[props.childField];
        }
        return true;
    };

    const onSettingUpdated = (e) => {
        if (props.onSettingUpdated) props.onSettingUpdated(e);
        // reload();
        // if (grid.current) grid.current.reload(parentInfo);
        // if (tree.current) tree.current.reload(parentInfo);
        // if (form.current) form.current.reload(parentInfo);
    };

    const showAlert = async (args, onClosedCallback) => {
        if (msgBox.current) msgBox.current.show(args, onClosedCallback);
    };

    const getForm = () => {
        if (form.current) return form.current;
        return null;
    };
    useImperativeHandle(ref, () => ({
        showAlert: showAlert,
        getForm: getForm
    }));

    var showTitle = props.showTitle !== undefined ? props.showTitle : true;
    var showGrid = props.grid !== undefined;
    var showTree = props.tree !== undefined;
    var showForm = props.form !== undefined;

    var showDelete =
        props.showDelete !== undefined
            ? props.showDelete
            : props.grid && props.grid.showDelete !== undefined
            ? Boolean(props.grid.showDelete)
            : props.tree && props.tree.showDelete !== undefined
            ? Boolean(props.tree.showDelete)
            : true;

    var showEdit =
        props.showEdit !== undefined
            ? props.showEdit
            : props.grid && props.grid.edit !== undefined
            ? Boolean(props.grid.edit)
            : props.tree && props.tree.edit !== undefined
            ? Boolean(props.tree.edit)
            : Boolean(props.edit);
    var showAdd =
        props.showAdd !== undefined
            ? props.showAdd
            : props.grid && props.grid.add !== undefined
            ? Boolean(props.grid.add)
            : props.tree && props.tree.add !== undefined
            ? Boolean(props.tree.add)
            : Boolean(props.add);

    var showImport =
        props.showImport !== undefined
            ? props.showImport
            : props.grid && props.grid.import !== undefined
            ? Boolean(props.grid.import)
            : props.tree && props.tree.import !== undefined
            ? Boolean(props.tree.import)
            : Boolean(props.import);

    var showDownload = props.showDownload !== undefined ? props.showDownload : true;
    var showDetail = props.showDetail !== undefined ? props.showDetail : undefined;
    // var showFilterBySelected = props.showFilterBySelected !== undefined ? props.showFilterBySelected : false;
    var showSearchBar = props.showSearchBar !== undefined ? props.showSearchBar : true;
    var searchBarWidth = props.searchBarWidth !== undefined ? props.searchBarWidth : undefined;

    var showFieldChooser = props.showFieldChooser !== undefined ? props.showFieldChooser : true;

    return (
        <React.Fragment>
            <div>
                {showTitle && (
                    <AntToolbar
                        title={props.title ? props.title : API.entityDisplay ? API.entityDisplay : props.entityDisplay}
                        isH4={props.isH4 !== undefined ? props.isH4 : false}
                        isH5={props.isH5 !== undefined ? props.isH5 : true}
                        upperCase={props.upperCase}
                        showHelp={false}
                    />
                )}

                {showGrid && (
                    <AntSettingGrid
                        ref={grid}
                        API={props.grid && props.grid.API ? props.grid.API : API}
                        table={props.grid && props.grid.table ? props.grid.table : props.table}
                        url={props.grid ? props.grid.url : undefined}
                        entityName={API.entityName ? API.entityName : props.entityName}
                        entityDisplay={API.entityDisplay ? API.entityDisplay : props.entityDisplay}
                        loadFunc={props.grid ? props.grid.loadFunc : undefined}
                        // remotePaging={props.grid ? props.grid.remotePaging : undefined}
                        remotePaging={false}
                        isSearching={props.grid && props.grid.isSearching !== undefined ? props.grid.isSearching : false}
                        search={props.grid && props.grid.search ? props.grid.search : props.search}
                        searchConditions={gridSearchConditions}
                        searchFields={gridSearchFields}
                        sortable={props.grid && props.grid.sortable !== undefined ? props.grid.sortable : true}
                        selectable={showEdit || showDelete}
                        selectionMode={props.grid?.selectionMode}
                        defaultPageSize={props.grid && props.grid.defaultPageSize !== undefined ? props.grid.defaultPageSize : undefined}
                        allowedPageSizes={props.grid && props.grid.allowedPageSizes !== undefined ? props.grid.allowedPageSizes : [7, 15, 25]}
                        columns={props.grid ? props.grid.columns : []}
                        fields={props.fields}
                        cellStyles={props.grid?.cellStyles}
                        cellRenders={props.grid?.cellRenders}
                        cellContext={props.grid?.cellContext}
                        rowStyles={props.grid?.rowStyles}
                        showFilterGroups={props.grid?.showFilterGroups}  
                        showRowActions={props.grid?.showRowActions}              
                        rowActionPack={props.grid?.rowActionPack}
                        rowActions={props.grid?.rowActions}
                        rowActionWidth={props.grid?.rowActionWidth}
                        rowActionsDisplay={props.grid?.rowActionsDisplay}
                        rowActionPrimaryActions={props.grid?.rowActionPrimaryActions}
                        batchActions={props.grid?.batchActions}
                        autoBatchActions={props.grid?.autoBatchActions}
                        canEditAction={props.grid?.canEditAction}
                        canDeleteAction={props.grid?.canDeleteAction}
                        onBatchExecuted={props.grid?.onBatchExecuted}
                        actionItems={props.grid?.actionItems}
                        onAction={props.grid?.onAction}
                        edit={props.grid && props.grid.edit ? props.grid.edit : props.edit}
                        add={props.grid && props.grid.add ? props.grid.add : props.add}
                        delete={props.grid && props.grid.delete ? props.grid.delete : props.delete}
                        import={props.grid && props.grid.import ? props.grid.import : props.import}
                        showActionBar={props.grid?.showActionBar}
                        showEdit={showEdit}
                        showDelete={showDelete}
                        showAdd={showAdd}
                        showImport={showImport}
                        showDownload={showDownload}
                        showDetail={showDetail}
                        showIndex={props.grid?.showIndex}
                        // showFilterBySelected={showFilterBySelected}
                        showFieldChooser={showFieldChooser}
                        showSearchBar={showSearchBar}
                        searchBarWidth={searchBarWidth}
                        searchCategories1={props.grid && props.grid.searchCategories1 ? props.grid.searchCategories1 : undefined}
                        searchCategories2={props.grid && props.grid.searchCategories2 ? props.grid.searchCategories2 : undefined}
                        searchCategories3={props.grid && props.grid.searchCategories3 ? props.grid.searchCategories3 : undefined}
                        searchCategories4={props.grid && props.grid.searchCategories4 ? props.grid.searchCategories4 : undefined}
                        searchCategories5={props.grid && props.grid.searchCategories5 ? props.grid.searchCategories5 : undefined}
                    />
                )}

                {/* {showTree && (
                    <AntSettingTree
                        ref={tree}
                        session={props.session}
                        API={props.tree && props.tree.API ? props.tree.API : API}
                        table={props.tree && props.tree.table ? props.tree.table : props.table}
                        url={props.tree ? props.tree.url : undefined}
                        entityName={API.entityName ? API.entityName : props.entityName}
                        entityDisplay={API.entityDisplay ? API.entityDisplay : props.entityDisplay}
                        keyExpr={props.tree ? props.tree.keyExpr : undefined}
                        parentIdExpr={props.tree ? props.tree.parentIdExpr : undefined}
                        loadFunc={props.tree ? props.tree.loadFunc : undefined}
                        searchConditions={treeSearchConditions}
                        searchFields={treeSearchFields}
                        sortable={props.tree && props.tree.sortable !== undefined ? props.tree.sortable : true}
                        selectable={true}
                        allowedPageSizes={props.tree && props.tree.allowedPageSizes !== undefined ? props.tree.allowedPageSizes : [7, 15, 25]}
                        columns={props.tree ? props.tree.columns : []}
                        fields={props.fields}
                        autoExpandAll={props.tree ? props.tree.autoExpandAll : undefined}
                        actionItems={props.tree ? props.tree.actionItems : []}
                        showActionBar={props.tree ? props.tree.showActionBar : undefined}
                        edit={props.grid && props.grid.edit ? props.grid.edit : props.edit}
                        add={props.grid && props.grid.add ? props.grid.add : props.add}
                        import={props.grid && props.grid.import ? props.grid.import : props.import}
                        showEdit={showEdit}
                        showDelete={showDelete}
                        showAdd={showAdd}
                        showImport={showImport}
                        showDownload={showDownload}
                        showFieldChooser={showFieldChooser}
                        showSearchBar={showSearchBar}
                        locationRefresh={props.tree ? props.tree.locationRefresh : undefined}
                        locationEdit={props.tree ? props.tree.locationEdit : undefined}
                        locationDelete={props.tree ? props.tree.locationDelete : undefined}
                        locationAdd={props.tree ? props.tree.locationAdd : undefined}
                        locationImport={props.tree ? props.tree.locationImport : undefined}
                        locationDownload={props.tree ? props.tree.locationDownload : undefined}
                        locationSearchBar={props.tree ? props.tree.locationSearchBar : undefined}
                        onImport={() => {
                            if (tree.current && this.importPopup) this.importPopup.show(parentInfo);
                        }}
                    />
                )} */}

                {showForm && (
                    <AntSettingForm
                        ref={form}
                        API={API}
                        settingGroup={props.form ? props.form.settingGroup : undefined}
                        settingCodes={props.form?.settingCodes}
                        refreshKey={props.refreshKey}
                        render={props.render}
                        searchConditions={formSearchConditions}
                        isAllowQuery={isAllowQuery}
                        alignItemLabelsInAllGroups={props.form ? props.form.alignItemLabelsInAllGroups : undefined}
                        labelLocation={props.form ? props.form.labelLocation : undefined}
                        labelAlignment={props.form ? props.form.labelAlignment : undefined}
                        allCheckBoxLeft={true}
                        colCount={props.form ? props.form.colCount : 1}
                        onFieldDataChanged={props.form ? props.form.onFieldDataChanged : undefined}
                        onSaving={props.form ? props.form.onSaving : undefined}
                        onError={props.form ? props.form.onError : undefined}
                        onSaved={onSettingUpdated}
                        autoRefreshToken={props.autoRefreshToken}
                        fields={props.form ? props.form.fields : []}
                        items={props.form ? props.form.items : []}
                        showLoading={props.form?.showLoading}
                        form={props.form}
                        onHasVisibleItems={props.onHasVisibleItems}
                        showAsCardField={props.showAsCardField}
                    />
                )}
                {props.children}
                <AntMessageBox ref={msgBox} />
            </div>
        </React.Fragment>
    );
});
